import React from 'react';
import useMileage, {ChallengeType} from '@di-shared/features/mileage/useMileage';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useOdometer from '@di-shared/features/mileage/useOdometer';

interface HomeMileageInnerContentsEcoKrProps {
  vin: string;
}

function HomeMileageInnerContentsEcoKr({vin}: HomeMileageInnerContentsEcoKrProps): JSX.Element {
  const {t} = useInferableTranslation();
  const {getChallengeType} = useMileage(vin);
  const {odometer} = useOdometer(vin);
  const challengeType = getChallengeType(odometer);

  function getMileageAmountText(challengeType: ChallengeType): string {
    switch (challengeType) {
      case ChallengeType.SEVEN:
        return t('T10125_$mileage', {mileage: 7});
      case ChallengeType.FIVE:
        return t('T10125_$mileage', {mileage: 5});
      case ChallengeType.TRREE:
        return t('T10125_$mileage', {mileage: 3});
      case ChallengeType.TWO:
        return t('T10125_$mileage', {mileage: 2});
      case ChallengeType.UPDATE_STATUS:
        return t('T10133');
      case ChallengeType.CHALLENGE_UNAVAILABLE:
      default:
        return '';
    }
  }

  return (
    <li className="eco_state_item">
      <strong className="eco_state_title">{t('T10124')}</strong>
      <p
        className="eco_state_desc"
        style={{whiteSpace: 'pre-wrap'}}
      >
        {getMileageAmountText(challengeType)}
      </p>
      {challengeType === ChallengeType.CHALLENGE_UNAVAILABLE ? (
        <div className="badge_box">
          <span className="badge badge_container_red badge_20px">{t('T10128')}</span>
        </div>
      ) : challengeType === ChallengeType.UPDATE_STATUS ? null : (
        <div className="badge_box">
          <span className="badge badge_basic_container badge_20px">{t('T10126')}</span>
        </div>
      )}
    </li>
  );
}

export default HomeMileageInnerContentsEcoKr;

export function HomeMileageInnerContentsEcoError() {
  const {t} = useInferableTranslation();
  return (
    <li className="eco_state_item">
      <strong className="eco_state_title">{t('T10124')}</strong>
      <p className="eco_state_desc">{t('T10136')}</p>
      <div className="badge_box">
        <span className="badge badge_basic_container badge_20px">{t('T10126')}</span>
      </div>
    </li>
  );
}
